import { SectionContentHeader } from "./SectionContentHeader";

export default SectionContentHeader;